<template>
  <div class="grid grid-cols-12 col-gap-14 row-gap-8">
    <div class="col-span-12 grid grid-cols-8 col-gap-8">
      <div @click="updateFilter({name: 'type', value:'income'})"
           class="type-picker --green col-span-2"
           :class="currentType === 'income' && '--active'">
        {{ $t('income') }}
      </div>
      <div @click="updateFilter({name: 'type', value:'expense'})"
           class="type-picker --red col-span-2"
           :class="currentType === 'expense' && '--active'">
        {{ $t('expense') }}
      </div>
    </div>
    <div class="col-span-12 grid grid-cols-12 col-gap-8">
      <component :is="filterComponent"
                 v-bind="filters"
                 @updateFilter="updateFilter($event)"
                 @fetchReport="fetchReport"/>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import ReportIncomeFilters from "@/components/cabinet/Money/Reports/ReportIncome/ReportIncomeFilters";
import ReportExpenseFilters from "@/components/cabinet/Money/Reports/ReportExpense/ReportExpenseFilters";

export default {
  name: "ReportsFilters",
  components: {BaseSelect},
  computed: {
    ...mapState('reports/report_filters', ['filters', 'filters_data']),
    filterComponent() {
      return this.filters.type === 'income' ? ReportIncomeFilters : ReportExpenseFilters;
    },
    currentType() {
      return this.filters.type
    }
  },
  methods: {
    ...mapMutations('reports/report_filters', ['updateFilter', 'clearFilters']),
    setInitialRange() {
      let now = this.$moment().format('YYYY-MM-DD'),
          month_start = this.$moment().subtract(12, 'month').format('YYYY-MM-DD'),
          value = {start: month_start, end: now}
      this.updateFilter({name: 'date', value})
      this.fetchReport();
    },
    fetchReport(date_dirty) {
      this.$store.dispatch(`reports/report_${this.filters.type}/fetchReportData`, date_dirty)
    }
  },
  created() {
    this.$store.commit(`reports/report_${this.filters.type}/resetPagination`);
    this.setInitialRange();
  },
  watch: {
    'filters.type': {
      handler() {
        this.$store.dispatch(`reports/report_${this.filters.type}/fetchReportData`)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        income: 'Incomes',
        expense: 'Expenses',
      },
      ru: {
        income: 'Доходы',
        expense: 'Расходы',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.type-picker {
  @apply border border-border rounded flex items-center justify-center
  text-md text-text-label cursor-pointer transition duration-200 bg-block py-4-5;

  &.--green {
    &:hover {
      @apply text-green border-green;
    }

    &.--active {
      @apply text-green bg-green-extraLight border-green;
    }
  }

  &.--red {
    &:hover {
      @apply text-red border-red;
    }

    &.--active {
      @apply text-red bg-red-extraLight border-red;
    }
  }
}
</style>